import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Next from "./Next";
import ShowDetailSignup from "./SignUpCompo/ShowDetailsSignup";
import "./auth-modern.css";

function OTPInput({ sentOtp, email,type,setProgress,progress,prof }) {
  const [otp, setValue] = useState("");
  const [next, setNext] = useState(false);

  useEffect(() => {
    // Android/Chrome WebOTP: fill the SMS verification code automatically when supported.
    // The regular one-time-code autocomplete remains as a fallback on other devices.
    if (type !== "phone" || typeof window === "undefined" || !window.OTPCredential || !navigator.credentials) {
      return undefined;
    }

    const abortController = new AbortController();

    navigator.credentials
      .get({
        otp: { transport: ["sms"] },
        signal: abortController.signal,
      })
      .then((credential) => {
        if (credential?.code) {
          setValue(String(credential.code).replace(/\D/g, "").slice(0, 6));
        }
      })
      .catch((error) => {
        if (error?.name !== "AbortError") {
          console.log("WebOTP unavailable:", error);
        }
      });

    return () => abortController.abort();
  }, [type]);

  useEffect(() => {
    if (otp.length === 6 && otp.toString() === sentOtp.toString()) {
      setProgress(2);
      setNext(true);
    }
  }, [otp, sentOtp, setProgress]);

  const handleChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "").slice(0, 6);
    setValue(digitsOnly);
  };

  const handleSubmit = () => {
    if (otp.toString() === sentOtp.toString()) {
      console.log(otp)
      setProgress(2);
      setNext(true);
    };
  };

  return (
    <Box className="auth-modern-otp" style={{ textAlign: "center" }}>
      {!next && (
        <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
          <Typography
            variant="h6"
            sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#153B66" }}
          >
            הזן את הקוד שנשלח אליך
          </Typography>
          <Typography
            sx={{
              mt: 0.75,
              mb: 2,
              fontFamily: `${process.env.REACT_APP_FONT}`,
              color: "#60758A",
              fontSize: "14.5px",
            }}
          >
            קוד אימות בן 6 ספרות
          </Typography>

          <input
            className="auth-modern-one-time-code"
            type="text"
            value={otp}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter" && otp.length === 6) handleSubmit();
            }}
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={6}
            autoComplete="one-time-code"
            name="one-time-code"
            aria-label="קוד אימות בן 6 ספרות"
            autoFocus
          />

          <Button
            variant={otp.length===6?"contained":"outlined"}
            disabled={otp.length !== 6}
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              mt: 2.5,
              mb: 2,
              minHeight: 50,
              minWidth: 220,
              fontSize: "1.05rem",
              fontWeight: 800,
              borderRadius: "14px",
              textTransform: "none",
            }}
            onClick={handleSubmit}
          >
            המשך
          </Button>
          <ShowDetailSignup text={'הזן את הקוד שנשלח אליך למספר הטלפון'}/>
        </Box>
      )}
      {next && <Next email={email} token="no" which="no" type={type} setProgress={setProgress}progress={progress} prof={prof}/>} 
    </Box>
  );
}

export default OTPInput;
